import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Snakkeboble from "./../";
export const _frontmatter = {
  "ingress": "Snakkebobler brukes for å vise en direkte melding eller informasjon fra en konkret avsender. Snakkebobler bør brukes som del av en logg over beskjeder sendt frem og tilbake mellom to eller flere deltagere."
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#venstrejustert"
          }}>{`Venstrejustert`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#høyrejustert"
          }}>{`Høyrejustert`}</a></li></ol></nav>
    <h2 {...{
      "id": "venstrejustert"
    }}>{`Venstrejustert`}</h2>
    <Example mdxType="Example">
  <Snakkeboble topp="14.07.2017 kl. 10:12" mdxType="Snakkeboble">
    Hei! Jeg lurer på en ting...
  </Snakkeboble>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Snakkeboble topp="14.07.2017 kl. 10:12">
  Hei! Jeg lurer på en ting...
</Snakkeboble>
`}</code></pre>
    <h2 {...{
      "id": "høyrejustert"
    }}>{`Høyrejustert`}</h2>
    <Example mdxType="Example">
  <Snakkeboble topp="14.07.2017 kl. 10:12" pilHoyre={true} mdxType="Snakkeboble">
    Hei! Jeg lurer på en ting...
  </Snakkeboble>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Snakkeboble topp="14.07.2017 kl. 10:12" pilHoyre={true}>
  Hei! Jeg lurer på en ting...
</Snakkeboble>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      